import { Title } from './components/Title';
export function MainHeading(props) {
    return <Title appearance="main" as="h1" {...props}/>;
}
export function PageHeading(props) {
    return <Title appearance="page" as="h2" {...props}/>;
}
export function SectionHeading(props) {
    return <Title appearance="section" as="h3" {...props}/>;
}
export function SectionSubHeading(props) {
    return <Title appearance="subsection" as="h4" {...props}/>;
}
export function LabelHeading(props) {
    return <Title appearance="label" as="h4" {...props}/>;
}
